import { configureStore } from "@reduxjs/toolkit";
import notificationReducer from "../features/userNotifications/notificationSlice";
import compartirMascotaReducer from "../features/pets/compartirMascotaSlice";

export default configureStore({
  reducer: {
    notification: notificationReducer,
    compartirMascota: compartirMascotaReducer,
  },
});
